import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'currency' })
export class CustomCurrencyPipe extends CurrencyPipe implements PipeTransform {
    transform(value: string | number, currencyCode?: string, display?: string | boolean, digitsInfo?: string, locale?: string): string;
    transform(value: null, currencyCode?: string, display?: string | boolean, digitsInfo?: string, locale?: string): null;
    transform(value: string | number, currencyCode?: string, display?: string | boolean, digitsInfo?: string, locale?: string): string {
        if (currencyCode == undefined) currencyCode = 'EUR';
        if (currencyCode == 'EUR2') currencyCode = 'EUR';
        return super.transform(value, currencyCode+' ', display, digitsInfo, locale);
    }
}